import React, { useState, useEffect } from "react";
import Header from "../components/header";
import { apiurl } from "../config/config";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ApplicationForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    maritalStatus: "",
    currentAddress: "",
    permanentAddress: "",
    location: "",
    email: "",
    phone: "",
    gender: "",
    aadharNumber: "",
    aadharCard: "",
    totalExperience: "",
    previousCompany: "",
    previousDesignation: "",
    employmentDuration: "",
    reasonForLeaving: "",
    currentCTC: "",
    expectedCTC: "",
    noticePeriod: "",
    dob: "",
    qualification: "",
    relevantExperience: "",
    resume: "",
    department: "sales",
    position: "executive",
    referenceType: "",
    employeeName: "",
    employeeId: "",
    recruiterName: "",
    recruiterId: "",
    walkInReference: "",
    otherReference: "",
    consultancyReference: "",
    experienceType: "",
    customPosition: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [responsePopup, setResponsePopup] = useState(null);
  const [verified, setVerified] = useState(false);
  const [candidateData, setCandidateData] = useState(null);
  const [error, setError] = useState("");
  const [uploading, setUploading] = useState(false);
  const [uploadMessage, setUploadMessage] = useState("");
  const [experienceType, setExperienceType] = useState("fresher"); // 'fresher' or 'experienced'
  const [recruiters, setRecruiters] = useState([]); // ✅

  // const [otpSent, setOtpSent] = useState(false);
  // const [enteredOtp, setEnteredOtp] = useState("");
  // const [serverOtp, setServerOtp] = useState("");
  // const [otpVerified, setOtpVerified] = useState(false);

  // const handleSendOtp = async () => {
  //   if (!formData.email || !formData.firstName) {
  //     alert("Enter email and name first.");
  //     return;
  //   }

  //   try {
  //     const response = await axios.post(`${apiurl}/api/emailotp/send`, {
  //       email: formData.email,
  //       name: formData.firstName + " " + formData.lastName,
  //     });

  //     if (response.data.success) {
  //       setOtpSent(true);
  //       setServerOtp(response.data.otp); // only if not hashed
  //       toast.success("OTP sent to email!");
  //     } else {
  //       toast.error("Failed to send OTP.");
  //     }
  //   } catch (error) {
  //     console.error("Send OTP Error:", error);
  //     toast.error("Error sending OTP");
  //   }
  // };

  // const handleVerifyOtp = async () => {
  //   try {
  //     const response = await axios.post(`${apiurl}/api/emailotp/verify`, {
  //       email: formData.email,
  //       otp: enteredOtp,
  //     });

  //     if (response.data.success) {
  //       setOtpVerified(true);
  //       toast.success("Email verified!");
  //     } else {
  //       toast.error("Invalid OTP.");
  //     }
  //   } catch (error) {
  //     console.error("Verify OTP Error:", error);
  //     toast.error("Error verifying OTP");
  //   }
  // };

  // 'fresher' or 'experienced'

  const [otpSent, setOtpSent] = useState(false);
  const [enteredOtp, setEnteredOtp] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);

  const handleSendOtp = async () => {
    if (!formData.email || !formData.firstName) {
      alert("Enter email and name first.");
      return;
    }

    try {
      const response = await axios.post(`${apiurl}/api/emailotp/send`, {
        email: formData.email,
        name: `${formData.firstName} ${formData.lastName}`,
      });

      if (response.data.success) {
        setOtpSent(true);
        toast.success("OTP sent to email!");
      } else {
        toast.error("Failed to send OTP.");
      }
    } catch (error) {
      console.error("Send OTP Error:", error);
      toast.error("Error sending OTP");
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const response = await axios.post(`${apiurl}/api/emailotp/verify`, {
        email: formData.email,
        otp: enteredOtp,
      });

      if (response.data.success) {
        setOtpVerified(true);
        toast.success("Email verified!");
      } else {
        toast.error("Invalid OTP.");
      }
    } catch (error) {
      console.error("Verify OTP Error:", error);
      toast.error("Error verifying OTP");
    }
  };

  useEffect(() => {
    if (formData.aadharNumber.length === 12) {
      fetchCandidateData(formData.aadharNumber);
    }
  }, [formData.aadharNumber]);

  const fetchCandidateData = async (aadharNumber) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${apiurl}/api/candidate/find/${aadharNumber}`
      );
      if (response.data.success && response.data.found) {
        // setFormData({});
        setFormData({ ...formData, ...response.data.candidate.personalInfo });
        setCandidateData(response.data.candidate);
      }
    } catch (error) {
        console.error("Error fetching candidate data:", error);
    // In case of error — also clear
    setFormData({});
    setCandidateData(null);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData({ ...formData, [name]: type === "file" ? files[0] : value });

    const selectedDate = new Date(value);
    const today = new Date();
    const age = today.getFullYear() - selectedDate.getFullYear();
    const monthDiff = today.getMonth() - selectedDate.getMonth();
    const dayDiff = today.getDate() - selectedDate.getDate();

    if (
      age < 18 ||
      (age === 18 && (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)))
    ) {
      setError("You are not eligible to apply for this job.");
    } else {
      setError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const payload = {
      aadharNumber: formData.aadharNumber,
      location: formData.location,
      positionTitle:
        formData.position === "other"
          ? formData.customPosition || "executive"
          : formData.position || "executive",
      department: formData.department || "sales",
      personalInfo: {
        firstName: formData.firstName,
        lastName: formData.lastName,
        dateOfBirth: formData.dob,
        gender: formData.gender,
        maritalStatus: formData.maritalStatus,
        phone: formData.phone,
        email: formData.email,
        permanentAddress: formData.permanentAddress,
        currentAddress: formData.currentAddress,
      },
      identification: { aadharNumber: formData.aadharNumber },
      education: [
        {
          qualification: formData.qualification,
          institution: "",
          yearOfPassing: "",
          percentage: "",
        },
      ],
      professionalInfo: {
        experienceType: experienceType,
        totalExperience: formData.totalExperience,
        previousCompany: formData.previousCompany,
        designation: formData.previousDesignation,
        duration: formData.employmentDuration,
        reasonForLeaving: formData.reasonForLeaving,
        currentCTC: formData.currentCTC,
        expectedCTC: formData.expectedCTC,
        noticePeriod: formData.noticePeriod,
        // relevantExperience: formData.relevantExperience,
      },
      referenceDetails: {
        referenceType: formData.referenceType || "walkin",
        employeeName: formData.employeeName || "",
        employeeId: formData.employeeId || "",
        recruiterName: formData.recruiterName || "",
        recruiterId: formData.recruiterId || "",
        otherReference: formData.otherReference || "",
        consultancyReference: formData.consultancyReference || "",
        walkInReference: formData.walkInReference || "",
      },

      documents: {
        resume: {
          link: formData.resume || "",
          uploaded: !!formData.resume,
        },
        // photo: {
        //   link: { type: String, default: null },
        //   uploaded: { type: Boolean, default: false },
        // },
        aadharCard: {
          link: formData.aadharCard || "",
          uploaded: !!formData.aadharCard,
        },
      },
    };

try {
  const response = await axios.post(
    `${apiurl}/api/application/apply`,
    payload,
    {
      headers: { "Content-Type": "application/json" },
    }
  );

  // If backend returns success: false — don't treat as success
  if (response.data.success === false) {
    toast.error(response.data.message || "Something went wrong.");
    setSubmitting(false);
    return;
  }

  // SUCCESS
  setResponsePopup(response.data);
  toast.success("Application submitted successfully!");

  setTimeout(() => {
    navigate(
      `/tracking-details?applicationid=${response?.data?.application?.id}`
    );
  }, 3000);
} catch (error) {
  console.error("Error:", error);

  // Capture message properly
  const errorMsg =
    error?.response?.data?.message ||
    "Failed to submit application. Please try again.";

  toast.error(errorMsg);
} finally {
  setSubmitting(false);
}
  };
  console.log("formdata", formData);

  const handleFileUpload = async (e, field) => {
    console.log("Uploading field:", field);
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    setUploadMessage("");

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        `${apiurl}/api/media/resume`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response?.data?.success) {
        console.log("Upload response:", response);
        // setFormData((prev) => ({
        //   ...prev,
        //   [field]: response.data.fileUrl, // Ensure correct field is updated
        // }));

        setFormData((prev) => {
          const updatedForm = { ...prev, [field]: response.data.fileUrl };
          console.log("Updated formData:", updatedForm);
          return updatedForm;
        });

        setUploadMessage("File uploaded successfully!");
      } else {
        setUploadMessage("File upload failed. Please try again.");
      }
    } catch (error) {
      console.error("Upload error:", error);
      setUploadMessage("Error uploading file.");
    } finally {
      setUploading(false);
    }
  };

  const handleExperienceChange = (e) => {
    setExperienceType(e.target.value);
  };

  useEffect(() => {
    fetchRecruiters();
  }, []);

  const fetchRecruiters = async () => {
    try {
      const response = await axios.post(`${apiurl}/api/user/getbyrole`, {
        role: "recruiter",
        status: "active",
      });
      if (response.data.success) setRecruiters(response.data.users);
    } catch (err) {
      console.error("Error fetching trainers:", err);
    }
  };

  return (
    <>
      <Header />
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-2 py-4">
        <form
          onSubmit={handleSubmit}
          className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-3xl border border-[#39160d]"
        >
          <h2 className="text-xl md:text-3xl font-bold text-center text-[#39160d] mb-8">
            Application Form
          </h2>

          {candidateData && (
            <div className="mb-8 p-4 bg-blue-100 rounded-2xl">
              <h3 className="text-lg font-semibold">Candidate Profile</h3>
              <p>
                Name: {candidateData.personalInfo.firstName}{" "}
                {candidateData.personalInfo.lastName}
              </p>
              <p>Email: {candidateData.personalInfo.email}</p>
              <p>Phone: {candidateData.personalInfo.phone}</p>
            </div>
          )}

          <h3 className="text-md font-semibold mb-4">Applied For Position</h3>

          <div className="w-full">
            <select
              name="position"
              value={formData.position}
              onChange={(e) => {
                const value = e.target.value;
                setFormData((prev) => ({
                  ...prev,
                  position: value,
                  // Reset customPosition if switching away from "other"
                  customPosition:
                    value === "other" ? prev.customPosition || "" : "",
                }));
              }}
              className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            >
              <option value="">Select Position</option>
              <option value="executive">Executive (Sales)</option>
              <option value="atl">ATL (Sales)</option>
              <option value="tl">Team Leader (Sales)</option>
              <option value="manager">Manager (Sales)</option>
              <option value="other">Other</option>
            </select>

            {formData.position === "other" && (
              <input
                type="text"
                name="customPosition"
                placeholder="Enter custom position"
                className="mt-3 w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={formData.customPosition || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    customPosition: e.target.value,
                  }))
                }
              />
            )}
          </div>




                      <select
              name="location"
              value={formData.location}
              onChange={handleChange}
              className="w-full mt-3 p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            >
              <option value="">--Select Location--</option>
              <option value="altf-5th-floor">ALT F 5th Floor</option>
              <option value="gmit-5th-floor">GMIT 5th Floor</option>
              {/* <option value="other">Other</option> */}
            </select>

          <h3 className="text-md font-semibold my-4">Identification Details</h3>
          <div className="space-y-2">
            {/* <input
              type="text"
              name="aadharNumber"
              placeholder="Aadhar Number"
              value={formData.aadharNumber}
              onChange={handleChange}
              className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            /> */}
            <input
  type="text"
  name="aadharNumber"
  placeholder="Aadhar Number"
  value={formData.aadharNumber}
  onChange={(e) => {
    const value = e.target.value;

    // Allow ONLY numbers
    const numericOnly = value.replace(/[^0-9]/g, "");

    handleChange({
      target: {
        name: "aadharNumber",
        value: numericOnly,
      },
    });
  }}
  className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
  required
/>

            {errors.aadharNumber && (
              <p className="text-red-500 text-sm">{errors.aadharNumber}</p>
            )}
            {loading && (
              <p className="text-blue-500 text-sm">Finding Aadhar Number...</p>
            )}
            {verified && (
              <p className="text-green-500 text-sm">
                Your details were found in our records!
              </p>
            )}
          </div>

          <h3 className="text-md font-semibold mt-8 mb-4">
            Personal Information
          </h3>
          <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4">
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              value={formData.firstName}
              onChange={handleChange}
              className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              value={formData.lastName}
              onChange={handleChange}
              className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
            <select
              name="maritalStatus"
              value={formData.maritalStatus}
              onChange={handleChange}
              className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            >
              <option value="">Select Marital Status</option>
              <option value="unmarried">Unmarried</option>
              <option value="married">Married</option>
            </select>
            <input
              type="text"
              name="currentAddress"
              placeholder="Current Address"
              value={formData.currentAddress}
              onChange={handleChange}
              className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
            <input
              type="text"
              name="permanentAddress"
              placeholder="Permanent Address"
              value={formData.permanentAddress}
              onChange={handleChange}
              className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
            <input
              type="number"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
              min="1000000000"
              max="9999999999"
            />
            {errors.phone && (
              <p className="text-red-500 text-sm">{errors.phone}</p>
            )}
            <select
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            >
              <option value="">Select Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
            <div className="w-full">
              <label className="text-gray-500">Date of Birth</label>
              <input
                type="date"
                name="dob"
                value={formData.dob}
                placeholder="Date of Birth"
                onChange={handleChange}
                className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
              {error && <p className="text-red-500 mt-2">{error}</p>}
            </div>
          </div>

          <h3 className="text-md font-semibold mt-8 mb-4">
            Professional Information
          </h3>
          <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4">
            <select
              name="experienceType"
              value={experienceType}
              onChange={handleExperienceChange}
              className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            >
              <option value="">Select Experience Type</option>
              <option value="fresher">Fresher</option>
              <option value="experienced">Experienced</option>
            </select>

            {experienceType === "experienced" && (
              <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                <input
                  type="number"
                  name="totalExperience"
                  placeholder="Total Work Experience (in years)"
                  value={formData.totalExperience}
                  onChange={handleChange}
                  className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <input
                  type="text"
                  name="previousCompany"
                  placeholder="Previous Company"
                  value={formData.previousCompany}
                  onChange={handleChange}
                  className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <input
                  type="text"
                  name="previousDesignation"
                  placeholder="Designation"
                  value={formData.previousDesignation}
                  onChange={handleChange}
                  className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <input
                  type="text"
                  name="employmentDuration"
                  placeholder="Duration of Employment (in years)"
                  value={formData.employmentDuration}
                  onChange={handleChange}
                  className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <input
                  type="text"
                  name="reasonForLeaving"
                  placeholder="Reason for Leaving"
                  value={formData.reasonForLeaving}
                  onChange={handleChange}
                  className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <input
                  type="number"
                  name="currentCTC"
                  placeholder="Current CTC (in lakh)"
                  value={formData.currentCTC}
                  onChange={handleChange}
                  className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <input
                  type="number"
                  name="expectedCTC"
                  placeholder="Expected CTC (in lakh)"
                  value={formData.expectedCTC}
                  onChange={handleChange}
                  className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <input
                  type="text"
                  name="noticePeriod"
                  placeholder="Notice Period (in days)"
                  value={formData.noticePeriod}
                  onChange={handleChange}
                  className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <input
                  type="text"
                  name="relevantExperience"
                  placeholder="Relevant Experience (if any)"
                  value={formData.relevantExperience}
                  onChange={handleChange}
                  className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            )}
            <input
              type="text"
              name="qualification"
              placeholder="Highest Qualification"
              value={formData.qualification}
              onChange={handleChange}
              className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          <h3 className="text-md font-semibold my-4">Applied From</h3>
          <select
            name="referenceType"
            value={formData.referenceType}
            onChange={handleChange}
            className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          >
            <option value="">Select Reference Type</option>
            <option value="walkin">Walk-in</option>
            <option value="recruiter">HR </option>
            <option value="employee">Employee Reference</option>
            <option value="consultancy">Consultancy</option>
            <option value="other">Other</option>
          </select>

          {/* Employee Reference Fields */}
          {formData.referenceType === "employee" && (
            <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              <input
                type="text"
                name="employeeName"
                placeholder="Employee Name"
                value={formData.employeeName}
                onChange={handleChange}
                className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="text"
                name="employeeId"
                placeholder="Employee ID"
                value={formData.employeeId}
                onChange={handleChange}
                className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          )}
          {formData.referenceType === "recruiter" && (
            <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              <select
                className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={formData.recruiterId}
                onChange={(e) => {
                  const selected = recruiters.find(
                    (r) => r?.employeeDetails?.employeeId === e.target.value
                  );
                  setFormData({
                    ...formData,
                    recruiterId: selected?.employeeDetails?.employeeId || "",
                    recruiterName: `${selected?.firstName || ""} ${
                      selected?.lastName || ""
                    }`,
                  });
                }}
              >
                <option value="">Select HR</option>
                {Array.isArray(recruiters) &&
                  recruiters.map((recruiter) => (
                    <option
                      key={recruiter?._id}
                      value={recruiter?.employeeDetails?.employeeId}
                    >
                      {recruiter?.firstName} {recruiter?.lastName}
                    </option>
                  ))}
              </select>
            </div>
          )}

          {formData.referenceType === "other" && (
            <div className="mt-4">
              <textarea
                name="otherReference"
                placeholder="Describe Reference"
                value={formData.otherReference}
                onChange={handleChange}
                className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          )}

          {formData.referenceType === "consultancy" && (
            <div className="mt-4">
              <label className="block mb-2 font-semibold">
                Consultancy Company Name
              </label>
              <select
                name="consultancyReference"
                value={formData.consultancyReference}
                onChange={handleChange}
                className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">-- Select Name --</option>
                <option value="touchcore-consultancy">
                  Touchcore Consultancy
                </option>
                <option value="krishna-consultancy">Krishna consultancy</option>
                <option value="tr-consultancy">TR Consultancy</option>
                <option value="ahrs-consultancy">AHRS Consultancy</option>
                <option value="uplevel-solutions">Uplevel Solutions</option>
                <option value="talent-genics">Talent Genics</option>
                <option value="hirosity-consultancy">
                  Hirosity Consultancy
                </option>
                <option value="enlabs-technology">Enlabs Technology</option>
                <option value="arieswolf-consultancy">Arieswolf Consultancy</option>
                <option value="bridge-your-future-consulting">Bridge your future consulting</option>
              </select>
            </div>
          )}

          <h3 className="text-md font-semibold mt-8 mb-4">Uploads Resume/CV</h3>
          <input
            type="file"
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            onChange={(e) => handleFileUpload(e, "resume")}
            className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          {uploading && <p className="text-blue-500">Uploading...</p>}
          {uploadMessage && <p className="text-green-500">{uploadMessage}</p>}


            <button
              type="submit"
              disabled={uploading || submitting}
              className={` mt-4 w-full p-3 rounded-xl text-lg font-semibold transition 
            ${
              uploading || submitting
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-blue-600 text-white hover:bg-blue-700"
            }`}
            >
              {submitting ? "Submitting..." : "Register"}
            </button>

          {loading && (
            <p className="text-blue-500 text-sm">
              Loading candidate details...
            </p>
          )}
          {submitting && (
            <p className="text-green-500 text-sm">Submitting application...</p>
          )} 

          {/* {!otpSent && (
            <button
              type="button"
              className="mt-4 w-full p-3 rounded-xl text-lg font-semibold transition bg-blue-600 text-white hover:bg-blue-700"
              onClick={handleSendOtp}
            >
              Send OTP
            </button>
          )}

          {otpSent && !otpVerified && (
            <>
              <input
                type="text"
                placeholder="Enter OTP"
                className="w-full mt-3 p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={enteredOtp}
                onChange={(e) => setEnteredOtp(e.target.value)}
              />
              <button
                type="button"
                className="mt-4 w-full p-3 rounded-xl text-lg font-semibold transition bg-blue-600 text-white hover:bg-blue-700"
                onClick={handleVerifyOtp}
              >
                Verify OTP
              </button>
              <button
                type="button"
                className="mt-2 text-sm text-blue-500 underline"
                onClick={handleSendOtp}
              >
                Resend OTP
              </button>
            </>
          )}

          {otpVerified && (
            <span className="text-green-600 mt-2 block">Email verified ✅</span>
          )} */}

          {/* Register Button */}
          {/* <button
            type="submit"
            disabled={!otpVerified || uploading || submitting}
            className={`mt-4 w-full p-3 rounded-xl text-lg font-semibold transition ${
              !otpVerified || uploading || submitting
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-blue-600 text-white hover:bg-blue-700"
            }`}
          >
            {submitting ? "Submitting..." : "Register"}
          </button> */}

          {/* Optional Loading Indicators */}
          {loading && (
            <p className="text-blue-500 text-sm">
              Loading candidate details...
            </p>
          )}
          {submitting && (
            <p className="text-green-500 text-sm">Submitting application...</p>
          )}
        </form>
      </div>
      {responsePopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-xl shadow-xl text-center">
            <h2 className="text-xl font-bold">Application Submitted!</h2>
            <p className="mt-2">
              Application ID: {responsePopup?.application?.id}
            </p>
            <p className="mt-2 text-sm text-gray-500">
              Redirecting in 3 seconds...
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default ApplicationForm;
